import dayjs from "dayjs";
import { IDownloadRequest } from "../../interfaces/IDownloadRequest";
import { apiDownloadFileStream } from "../../services/ApiService";

export class FileDownLoader {
  static downloadFile = (blob: Blob, fileName: string) => {
    const nav = window.navigator as any;
    if (nav?.msSaveOrOpenBlob) {
      nav.msSaveOrOpenBlob(blob, fileName);
    }
    else {
      const url = window.URL.createObjectURL(new Blob([blob], { type: "application/pdf" }));
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }
  }

  static downloadFileStream = async (downloadRequestPayload: IDownloadRequest): Promise<void> => {
    const fileBlob: Blob = await apiDownloadFileStream(downloadRequestPayload);

    if (fileBlob) {
      const fileName = downloadRequestPayload?.items?.length === 1
        ? downloadRequestPayload.items[0].name
        : `Docubird - ${dayjs().format("YYYY-MM-DD_HH:mm:SSS")}.zip`;

      const nav = window.navigator as any;
      if (!nav?.msSaveOrOpenBlob) {
        const downloadUrl = window.URL.createObjectURL(fileBlob);
        const anchor = document.createElement("a");
        anchor.href = downloadUrl;
        anchor.download = fileName;
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
        window.URL.revokeObjectURL(downloadUrl);
      }
      else {
        nav.msSaveOrOpenBlob(fileBlob, fileName);
      }
    }
  }
}